// extracted by mini-css-extract-plugin
module.exports = {"root":"qNv4G","bg":"yy79E","arrow":"_1TJNl"};